import { FLYOUT_CLICKED, ON_VEHICLE_INFO_UPDATED, SELECTION_METHOD_CHANGED, ON_VALID_VIN_DATA, ON_RESET_VEHICLE_INFO, ON_VIN_UPDATED } from '../actions';
import selectedInfoUpdated from './operations/selectedInfoUpdated';
import resetSelectedInfo from './operations/resetSelectedInfo';
import { getSelectedEntryMapping } from './operations/getSelectedEntryMapping';
export function updateSelectedInfoEntries(state = new Map(), action) {
    switch (action.type) {
        case FLYOUT_CLICKED:
            return selectedInfoUpdated(state, action);
        case SELECTION_METHOD_CHANGED:
            return new Map();
        case ON_VALID_VIN_DATA:
            return resetSelectedInfo(state, action);
        case ON_VEHICLE_INFO_UPDATED:
            return resetSelectedInfo(state, action);
        case ON_RESET_VEHICLE_INFO:
            return new Map();
        case ON_VIN_UPDATED:
            return getSelectedEntryMapping(state, action);
        default:
            return state;
    }
}
//# sourceMappingURL=updateSelectedInfoEntries.js.map